// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoiceOrderInstructions_voice-order-instructions__Fm\\+Ti {
  width: auto;
  min-width: 45rem;
  flex-shrink: 0;
}

.VoiceOrderInstructions_voice-order-instructions__header__kSDVT {
  color: var(--primary-color);
  font-size: var(--text-lg);
  font-weight: 500;
  margin-bottom: 2rem;
}

.VoiceOrderInstructions_voice-order-instructions__list__TSVbu {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.VoiceOrderInstructions_voice-order-instructions__list-item__EKT0b {
  padding-block: 2rem;
  text-align: center;
  border-radius: 1rem;
  border: 1px solid var(--black-ten-opacity);
  color: var(--black-dark);
  font-size: var(--text-base);
  font-weight: 500;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .VoiceOrderInstructions_voice-order-instructions__Fm\\+Ti {
    min-width: 35rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VoiceOrder/VoiceOrderInstructions/VoiceOrderInstructions.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".voice-order-instructions {\n  width: auto;\n  min-width: 45rem;\n  flex-shrink: 0;\n}\n\n.voice-order-instructions__header {\n  color: var(--primary-color);\n  font-size: var(--text-lg);\n  font-weight: 500;\n  margin-bottom: 2rem;\n}\n\n.voice-order-instructions__list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.voice-order-instructions__list-item {\n  padding-block: 2rem;\n  text-align: center;\n  border-radius: 1rem;\n  border: 1px solid var(--black-ten-opacity);\n  color: var(--black-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .voice-order-instructions {\n    min-width: 35rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voice-order-instructions": `VoiceOrderInstructions_voice-order-instructions__Fm+Ti`,
	"voice-order-instructions__header": `VoiceOrderInstructions_voice-order-instructions__header__kSDVT`,
	"voice-order-instructions__list": `VoiceOrderInstructions_voice-order-instructions__list__TSVbu`,
	"voice-order-instructions__list-item": `VoiceOrderInstructions_voice-order-instructions__list-item__EKT0b`
};
export default ___CSS_LOADER_EXPORT___;
